import { combineReducers } from "redux"

import state from "./state/slice"

const appReducer = combineReducers({
  state,
})

export default appReducer
